<template>
<!-- 对账单详情 -->
    <div class="import-statement-detail"> 
        <div class="title">
            <h2>出口对账单</h2>
            <div>
                <el-button
                :loading="exportLoading"
                @click="exportFile('Pdf')"
                >打印PDF</el-button>
                <el-button
                :loading="exportLoading"
                @click="exportFile('Excel')"
                >下载Excel</el-button>
                <el-button
                @click="exportFile('OtherFeeExcel')"
                :loading="exportLoading"
                >下载杂费单</el-button>
            </div>
        </div>  

        <el-row class="statement-detail"> 
            <el-col :span="8">客户名称：<span>{{dataForm.principalName}}</span></el-col>
            <el-col :span="8">账单周期：<span class="">{{dataForm.periodTimeRegion}}</span></el-col>
            <el-col :span="8">发票类型：<span class="">6% 服务费发票</span></el-col>
            <el-col :span="16">结算条款：<span>{{dataForm.agencyFeeDesc}}</span></el-col>
            <div class="imgs" v-if="dataForm.statusDesc == '已确认'"><img src="../../assets/img/确认.png" alt=""></div>
        </el-row> 

        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane label="费用明细" name="first">
                <el-table
                    border
                    :data="dataForm.feeInfoEntryVoList" 
                    :showSummary="true"
                    :summary-method="(param) => getSummaries(param, ['customsAmount', 'importTariff', 'importAddedTax', 'consumeAmount', 'serviceAmount', 'incidentalAmount', 'penaltyAmount', 'subtotalAmount', 'receiptAmount', 'interestAmount', 'applyAmount', 'applyPayableAmount', 'drawAmount'])">
                    <el-table-column type="index" fixed  label="序号" width="60" align='center'></el-table-column>
                    <el-table-column v-for="(item,index) in columns" :key="index" :prop="item.props" :label="item.labels" class="aaa">
                        <el-table-column 
                            v-for="(k,idx) in item.children" 
                            :key="idx" 
                            :label="k.labels" 
                            :prop="k.props" 
                            :width="k.widths" 
                            :show-overflow-tooltip="true" 
                            :align="k.align">
                                <template #default="scope">
                                    <div v-if="k.props == 'incidentalAmount'">
                                        <span class="font-primary" @click="openDialog(scope.row)"> <!-- 杂费 -->
                                            {{ $filters.formatMoney(scope.row[k.props]) }}
                                        </span>
                                    </div>
                                    <div v-else-if="k.props == 'penaltyAmount'">  <!-- 违约金 -->
                                        <span class="font-primary" @click="openPenaltyDialog(scope.row)">
                                            {{ $filters.formatMoney(scope.row[k.props]) }}
                                        </span>
                                    </div>
                                    <div v-else-if="k.type == 'money'">
                                        {{ $filters.formatMoney(scope.row[k.props]) }}
                                    </div>
                                    
                                </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>

                
            </el-tab-pane>

            <el-tab-pane label="物料明细" name="second">
                <ab-table
                    stripe
                    border
                    showOrder
                    index-label="序号"
                    indexWidth="60"
                    maxHeight="394"
                    :column-list="goodsColumns"
                    :table-list="dataForm.goodsEntryList"
                    showSummary
                    :summaryMethod="(param) => getSummaries(param, ['qty', 'amount', 'importTariff', 'importAddedTax', 'consumeAmount', 'serviceAmount', 'incidentalAmount', 'subtotalAmount'])">
                </ab-table>    
            </el-tab-pane> 
        </el-tabs>    

        <el-row :gutter="20"  class="paymentDetails">
                    <el-col :span="4">
                        <div>
                            <span>结转上期应付余额</span>
                            <div class="money number">{{ dataForm.lastBalanceAmountStr }}</div>
                        </div>
                        <span class="bumber">1</span>
                    </el-col>
                    <el-col :span="4">
                        <div class="other">
                            <div>
                                <span>本期新增费用</span>
                                <div class="money number">{{ dataForm.currentSubtotalAmountStr }}</div>
                            </div>
                            <!-- <div>
                                <span>本期期末未付汇</span>
                                <div class="money number">{{ dataForm.currentUnpaidExchangeStr }}</div>
                            </div>
                            <div>
                                <span>逾期未付汇</span>
                                <div style="line-height: 26px" class="money number font-primary" @click="openOverdueDialog(dataForm)">{{ dataForm.overduePayableStr }}</div>
                            </div> -->
                        </div>
                        <span class="bumber">2</span>
                    </el-col>
                    <el-col :span="4">
                        <div>
                            <!-- <span>本期新增付汇款</span>
                            <div class="money number">{{ dataForm.currentNeedpayAmountStr }}</div> -->
                            <span>本期已付</span>
                            <div class="money number">{{ dataForm.currentReceiptAmountStr }}</div>
                        </div>
                        <span class="bumber">3</span>
                    </el-col>
                    <el-col :span="12">
                        <div class="other fore">
                            <div>
                                <span>本期期末未结汇</span>
                                <div class="money number">{{ dataForm.currentUnpaidExchangeStr }}</div>
                            </div>
                            <div>
                                <span>逾期未结汇</span>
                                <div style="line-height: 26px" class="money number font-primary" @click="openOverdueDialog(dataForm)">{{ dataForm.overduePayableStr }}</div>
                            </div>
                            <div>
                                <span>本期期末未开票</span>
                                <div class="money number">{{ dataForm.currentNotInvoicedAmount }}</div>
                            </div>
                        </div>
                        <span class="bumber"></span>
                    </el-col>
                </el-row>

        <div class="refundAccount">
            <div class="accountLeft">
                <div class="accountLeft-title">
                    <h5>回款账号</h5>
                    <div @click="copyData"><ab-svg name="my-fuzhi"></ab-svg>复制</div>
                </div>

                <el-alert title="请将以上应付款项付至我司银行账户，有什么疑问可以咨询客服！" type="warning" />

                <el-row>
                    <el-col :span="6">
                        <span>公司名称</span>
                        <div class="div-fs24">{{dataForm.trusteeName}}</div>
                    </el-col>
                    <el-col :span="8">
                        <span>开户银行</span>
                        <div class="div-fs24">{{dataForm.bankName}}</div>
                    </el-col>
                    <el-col :span="6">
                        <span>银行账号</span>
                        <div class="div-fs24">{{getAccountNumber(dataForm.accountNumber)}}</div>
                    </el-col>
                    <el-col :span="4">
                        <span>银行联行号</span>
                        <div class="div-fs24">{{dataForm.bankCode}}</div>
                    </el-col>
                </el-row>
            </div>

            <div class="accountRight">
                <h5>本期期末应付余额</h5>
                <div class="sumMoney">
                    <div>1</div>
                    <el-icon><Plus /></el-icon>
                    <div>2</div>
                    <el-icon><Minus /></el-icon>
                    <div>3</div>
                    <!-- <el-icon><Minus /></el-icon>
                    <div>4</div> -->
                </div>
                <div> <span v-if="dataForm.expireDateMin">{{ dataForm.expireDateMin }}到期</span></div>
                <div class="other number" v-if="dataForm.currentBalanceAmountList"> 
                    <div v-for="(item, index) of dataForm.currentBalanceAmountList" :key="index">
                        <span style="font-size: 24px">{{ item.value }}</span> {{ item.desc }}
                    </div>
                </div>
            </div>
        </div>

        <ab-upload
        @update-billsId="updateBillsId"
        ref="fileUpload"
        v-if="uploadParams.items && uploadParams.items.length"
        :params="uploadParams"></ab-upload>

        <ab-footer>
            <el-button @click="back">返回</el-button>
            <el-button 
                type="primary"
                :loading="isloading"
                v-if="$isAuth('customer:account:imAccounts:confirm') && dataForm.status === '2'"
                @click="confirmFun">确认</el-button>
        </ab-footer>
        <ab-preview :preview="preview" @handleClose="handleClose">
            <template #button>
                <el-button @click="close">关 闭</el-button>
            </template>
        </ab-preview>
        <import-statement-dialog :dialog="dialog"></import-statement-dialog>
        <import-statement-penalty-dialog :dialog="penaltyDialog"></import-statement-penalty-dialog>
        <import-statement-overdue-dialog :dialog="overdueDialog"></import-statement-overdue-dialog>
        <textarea style="width: 0; height: 0" id="inputCopy">这是幕后黑手</textarea>
    </div>
</template>

<script>
import importStatementDialog from './import-statement-dialog'
import importStatementPenaltyDialog from './import-statement-penalty-dialog'
import importStatementOverdueDialog from './import-statement-overdue-dialog'
export default {
    name: 'export-statement-detail',
    components: {
        importStatementDialog,
        importStatementPenaltyDialog,
        importStatementOverdueDialog
    },
    data() {
        return {
            activeName:'first',
            columns: [
                {
                    props: 'custOrderNo',
                    labels: '基本信息',
                    widths: 100,
                    show:true,
                    children:[
                        {
                            props: 'firstColumnShowStr',
                            labels: '出口日期',
                            widths: 120,
                        },
                        {
                            props: 'custOrderNo',
                            labels: '订单编号',
                            widths: 180
                        },
                        {
                            props: 'coreBillNumber',
                            labels: '系统单号',
                            widths: 180
                        },
                        {
                            props: 'customerIdDesc',
                            labels: '境外客户',
                            widths: 200,
                        },
                        {
                            props: 'customsNumber',
                            labels: '报关单号',
                            widths: 180,
                        },
                        {
                            props: 'customsAmount',
                            labels: '出口金额',
                            widths: 130,
                            type:'money',
                            align:'right'
                        },
                        {
                            props: 'customsCurrencyCode',
                            labels: '币别',
                            widths: 60,
                        },
                    ]
                },
                {
                    props: 'yingMoney',
                    labels: '应付款项',
                    widths: 80,
                    children:[
                        {
                            props: 'serviceAmount',
                            labels: '出口服务费',
                            widths: 100,
                            type:'money',
                            align:'right'
                        },
                        {
                            props: 'incidentalAmount',
                            labels: '杂费',
                            widths: 100,
                            type:'money',
                            align:'right'
                        },
                         {
                            props: 'penaltyAmount',
                            labels: '违约金',
                            widths: 80,
                            type:'money',
                            align:'right'
                        },
                         {
                            props: 'subtotalAmount',
                            labels: '费用小计',
                            widths: 100,
                            type:'money',
                            align:'right'
                        },
                    ]
                },
                {
                    props: 'yiMoney',
                    labels: '已付款项',
                    widths: 60, 
                    children:[
                        {
                            props: 'receiptTime',
                            labels: '付款日期',
                            widths: 160,
                        },
                        {
                            props: 'receiptAmount',
                            labels: '付款金额',
                            widths: 110,
                            type:'money',
                            align:'right',
                        },
                        {
                            props: 'receiptCurrencyCode',
                            labels: '币别',
                            widths: 60,
                        },
                    ]
                },
            ],
            goodsColumns: [
               {
                    labels: '订单编号',
                    props: 'custOrderNo',
                    widths: 160
                },
                {
                    labels: '出口日期',
                    props: 'portDate',
                    widths: 120
                },
                {
                    labels: '境外客户',
                    props: 'customerIdDesc',
                    widths: 220
                },
                {
                    labels: '报关单号',
                    props: 'customsNumber',
                    widths: 140
                },
                {
                    labels: '货物名称',
                    props: 'declareGoodsName',
                    widths: 180
                },
                {
                    labels: '规格型号',
                    props: 'model',
                    widths: 160
                },
                {
                    labels: '数量',
                    props: 'qty',
                    widths: 120
                },
                {
                    labels: '单位',
                    props: 'baseUnitName',
                    widths: 80
                },
                {
                    labels: '报关单价',
                    props: 'price',
                    widths: 100,
                    type: 'money',
                    align: 'right'
                },
                {
                    labels: '报关金额',
                    props: 'amount',
                    widths: 120,
                    type: 'money',
                    align: 'right'
                },
                {
                    labels: '币别',
                    props: 'currencyCode',
                    widths: 80
                },
                {
                    labels: '退税率',
                    props: 'backTaxRate',
                    widths: 80
                },
            ],
            exportLoading: false,
            isloading: false,
            routeQuery: {},
            dataForm: {},
            tempBillId: '',
            uploadParams: {
                coreBillIds: '',
                coreBillNumbers: '',
                sourceBillId: '',
                sourceBillNumber: '',
                sourceBillType: 'exportAccounts',
                billType: '',
                items: []
            },
            preview: {
                show: false,
                isView: false,
                isFooter: true,
                fileUrl: ''
            },
            dialog: {
                data: {},
                show: false
            },
            penaltyDialog: {
                data: {},
                show: false
            },
            penaltyDialog: {
                data: {},
                show: false
            },
            overdueDialog: {
                data: {},
                show: false
            },
        }
    },
     computed: {
        sidebarFold() {
          return this.$store.state.sidebarFold
        },
        mainTabs: {
            get() {
                return this.$store.state.mainTabs
            },
            set(val) {
                this.$store.commit('updateMainTabs', val)
            }
        },
        mainTabsActiveName: {
            get() {
                return this.$store.state.mainTabsActiveName
            },
            set(val) {
                this.$store.commit('updateMainTabsActiveName', val)
            }
        },

        sealText () {
            if (this.dataForm.status === '3') {
                return '已确认'
            } else if (this.dataForm.status === '2') {
                return '已复核'
            }
            return ''
        }
    },
    activated () {
        let query = this.$route.query || {}
        this.routeQuery = Object.keys(query).length ? query : this.routeQuery
        if ( typeof this.routeQuery.cache === "string" ? JSON.parse(this.routeQuery.cache) : this.routeQuery.cache) {
            return false
        } else {
            this.routeQuery.cache = true
        }
        this.init()
    },
    methods:{
        back () {
            this.$router.push({
                path: '/export-statement-list'
            })
        },
        close(){
            this.preview.show = false
            this.back()
        },
        init () {
            if (this.routeQuery.id) {
                this.$get('/sms/exportAccounts/get', { id: this.routeQuery.id }).then(({ data }) => {
                    if (data.code === 'C0000') {
                        data.result.feeInfoEntryVoList.forEach(row => {
                            row.portDate = row.portDate ? this.$utils.getDate(row.portDate) : ''
                            row.receiptTime = row.receiptTime ? this.$utils.getDate(row.receiptTime) : ''
                            row.applyPayDate = row.applyPayDate ? this.$utils.getDate(row.applyPayDate) : ''
                            row.applyArDate = row.applyArDate ? this.$utils.getDate(row.applyArDate) : ''
                            row.drawTime = row.drawTime ? this.$utils.getDate(row.drawTime) : ''
                        })
                        if (data.result.hasInterest && data.result.interestItemEntryList && data.result.interestItemEntryList.length) {
                            data.result.interestItemEntryList.forEach(row => {
                                row.bizDate = row.bizDate ? this.$utils.getDate(row.bizDate) : ''
                                row.arDate = row.arDate ? this.$utils.getDate(row.arDate) : ''
                                row.thisEndCalDate = row.thisEndCalDate ? this.$utils.getDate(row.thisEndCalDate) : ''
                            })
                            this.interestColumns.forEach(row => {
                                if (row.props === 'interest') {
                                    row.labels = '资金服务费\n' + data.result.interestFeeRateStr
                                }
                                if (row.props === 'penaltyMoney') {
                                    row.labels = '逾期金额\n' + data.result.penaltyRateStr
                                }
                            })
                        }
                        this.dataForm = data.result
                        if (this.dataForm.bizType != '01') {
                            this.columns[0].children = this.columns[0].children.filter(e => { return e.props != 'settleRate'})
                        }
                        this.initUpload()
                    } else {
                        this.$message.error(data.message)
                    }
                })
            }
        },
        initUpload () {
            // 初始化上传组件
            this.uploadParams.sourceBillId = this.dataForm.id
            this.uploadParams.sourceBillNumber = this.dataForm.number
            this.uploadParams.coreBillIds = this.dataForm.coreBillIds
            this.uploadParams.coreBillNumbers = this.dataForm.coreBillNumbers
            setTimeout(() => {
                let items = [
                    {
                        title: '对账单：',
                        attachType: '010',
                        required: false
                    }
                ]
                this.uploadParams.items = items
            }, 500)
        },
        //表格合计
        getSummaries(param,value) {
            const { columns, data } = param
            console.log(data);
            const sums = []
            columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计'
                return
            }
            let val= value.indexOf(column.property) != -1
            if(val && data){
                const values = data.map(item => Number(item[column.property]))
                sums[index]= values.reduce((prev, curr) => {
                    const value = Number(curr)
                    if (!isNaN(value)) {
                        return this.$calc.add(prev, curr)
                        } else {
                        return prev
                        }
                }, 0)
                sums[index] = this.$filters.formatMoney(sums[index])
            }
            })
            return sums
        },
        exportFile (type) {
            this.exportLoading = true
            this.$get('/sms/exportAccounts/derive' + type, { id: this.routeQuery.id }).then(({ data }) => {
                if (data && data.code === 'C0000') {
                    if (type === 'Pdf') {
                        data.result.map((url, idx) => {
                        setTimeout(() => {
                            this.windowOpenFile(url)
                        }, idx * 500)
                        })
                    } else {
                        this.windowOpenFile(data.message)
                    }
                } else {
                    this.$message.error(data.message)
                }
                this.exportLoading = false
            })
        },
         // 创建隐藏的可下载链接
        windowOpenFile (url) {
        // 创建隐藏的可下载链接
            var eleLink = document.createElement('a')
            eleLink.download = ''
            eleLink.target = '_blank'
            eleLink.style.display = 'none'
            // 字符内容转变成blob地址
            eleLink.href = url
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
        },
        confirmFun () {
            this.$refs.fileUpload.validate().then(() => {
                this.isloading = true
                this.$post('/sms/client/exportAccounts/clientConfirm', {id: this.dataForm.id}, this, 'btnLoading').then(({ data }) => {
                    if(data && data.code === 'C0000') {
                        this.$message({ message: data.message, type: 'success' })
                        if(data.result) {
                            this.preview.isView = true
                            this.preview.fileTitle = '进口对账单'
                            this.preview.fileUrl = data.result
                            this.preview.show = true
                        }else{
                            //返回
                            setTimeout(()=>{
                                this.back()
                            }, 1500)
                        }
                    }
                }).finally(()=>{
                    this.isloading = false
                })
            }).catch(e => {
                
            })
            
        },
        updateBillsId (tempBillId) {
            // 更新附件id
            this.tempBillId = tempBillId
        },
        handleClose () {
            this.init()
        },
        openDialog (row) {
            this.dialog.data = row
            this.dialog.show = true
        },
        openPenaltyDialog (row) {
            this.penaltyDialog.data = row
            this.penaltyDialog.show = true
        },
        openOverdueDialog (row) {
            this.overdueDialog.data = row
            this.overdueDialog.show = true
        },
        copyData () {
            var input = document.getElementById("inputCopy");  // 找到虚拟的输入框
            let temp = ''
            temp += '公司名称: ' + this.dataForm.trusteeName + '\n'
            temp += '开户银行: ' + this.dataForm.bankName + '\n'
            temp += '银行账号: ' + this.dataForm.accountNumber + '\n'
            temp += '银行联行号: ' + (this.dataForm.bankCode || '')
            input.value = temp; // 修改文本框的内容
            input.select(); // 选中文本
            document.execCommand("copy"); // 执行浏览器复制命令
            this.$message.success('复制成功!')
        },
        getAccountNumber(number) {
            if (number && number.length > 0) {
                let arry = number.split('')
                let str = ''
                arry.map((e, idx) => {
                    let index = idx + 1
                    if (index % 4 == 0) {
                        e = e + ' '
                    }
                    str += e
                })
               
               return str
            }
            
           
        }
    }
}
</script>

<style lang='scss'>
.import-statement-detail{
    padding: 25px 0;
    text-align: left;
    color: #000000;
    .title{
        position: relative;
        
        h2{
            height: 45px;
            line-height: 45px;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
        }
        &>div{
            position: absolute;
            right: 0;
            top: 0;
        }
    }
    .statement-detail{
        position: relative;
        padding: 30px 0 10px;
        margin-bottom: 40PX;
        font-size: 14px;
        border-bottom: 1px solid #F0F2F5;
        .el-col.el-col-8{
            margin-bottom: 30px;
        }
        .orange{
            color:#F87243 ;
        }
        .imgs{
            position: absolute;
            top: 22px;
            right: 0;
        }
    }
    .demo-tabs{
        /*去掉切换时el-tab-pane底部的蓝色下划线*/
        .el-tabs__active-bar {
            background-color: transparent !important;
        }
        /*去掉tabs底部的下划线*/
        .el-tabs__nav-wrap::after {
            position: static !important;
        }
        .el-tabs__item.is-top {
            padding: 0;
            margin-right: 40px;
            font-size: 16px;
            height: 50px;
            &.is-active {
                background-image: url(@/assets/img/nav-active.png);
                background-repeat: no-repeat;
                background-position: bottom;
                border-bottom: none;
                font-size: 18px;
            }
        }

        .el-tabs__content {
            margin-top: 30px;
        }
    }
    .el-table{
        margin-bottom: 40px;
        .el-table__header-wrapper{
            tr{
                th{
                    background-color: #f2f7ff;
                }
                &:first-child{
                    th{
                        text-align: center;
                    }
               }
            }
        }
        .el-table__footer-wrapper{
            td{
                color: #000000;
                background-color: #f2f7ff;
            }
        }
        
    }
    .paymentDetails{
        .el-col{
            position: relative;
            height: 117px;
            & > div{
                
                padding: 25px 3px 25px 25px;
                background-color: #F2F7FF;
                border-radius: 16px;
                span{
                    font-size: 14px;
                }
                .money{
                    font-size:20px;
                    font-weight: 500;
                    margin-top: 15px;
                }
           }
           .other{
                display: flex;
                justify-content: space-between;
           }
           .bumber{
                position: absolute;
                top: 0;
                left: 10px;
                width: 30px;
                border-radius: 16px 0 16px 0;
                text-align: center;
                line-height: 30px;
                background-color: #E2EEFF;
                color: #0A7CFF;
                font-size: 14px;
                font-weight: 500;
           }
        }
        .fore{
            &>div{
                flex: 1;
            }
        }
    }
    .refundAccount{
        display: flex;
        justify-content: space-between;
        margin: 40px 0;
        .accountLeft{
            width: 75%;
            border-right: 1px solid #f0f2f5;
            padding-right: 20px;
            .accountLeft-title{
                display: flex;
                justify-content: space-between;
                margin-bottom: 15px;
                cursor: pointer;
                .icon-svg{
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                    margin-right: 5px;
                }
            }
            .el-alert{
                margin-bottom: 12px;
            }
            .el-row{
                .el-col{
                    span{
                        display: inline-block;
                        font-size: 14px;
                        margin-bottom: 20px;
                    }
                    .div-fs24{
                       font-size: 18px;
                        font-weight: 500;
                    }
                    .div-fs18{
                        font-size: 16px;
                        font-weight: bold;
                    }
                }
            }
        }

        .accountRight{
            text-align: right;
            h5{
                font-size: 14px;
                margin-bottom: 14px;
            }
            .sumMoney{
                margin-bottom: 20px;                
                div{
                   display: inline-block; 
                   width: 30px;
                   height: 30px;
                   text-align: center;
                   line-height: 30px;
                   background-color: #E2EEFF ;
                   color:#0A7CFF ;
                   border-radius: 16px 0 16px 0;
                   font-size: 14px;
                   font-weight: 500;
                }
                i{
                    color: #7F7F7F;
                    margin: 0 12px;
                }
            }
            .other{
                font-size: 36px;
                color: #F87243;
                font-weight: 500;
            }
        }
    }
    .footer {
        margin: 0;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #F0F2F5;
        text-align: center;
    }
}
</style>